import { useNavigate, useLocation } from 'react-router-dom';
import { urls } from '~/tools/urls';
import { errors } from '~/tools/errors';
import { accountActions } from '~/behaviors/actions/account.actions';
import { useAppDispatch } from '~/behaviors';

const Logout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const queryParams = urls.parseQueryString(location.search);
  let withError: Error | null = null;

  // Check if tokenExpired was passed as reason for logout and logout
  // with error if it was.
  if (queryParams.reason && queryParams.reason === errors.types.tokenExpired) {
    withError = errors.createError({
      // @ts-ignore @TODO Epic WT-21600
      name: errors.types.tokenExpired,
      message: 'please login again',
    });
  }

  // The below action dispatch of `logout()` + `navigate('/login')` does the
  // work (which is the same as is done in the main nav component). This
  // route is defined merely as a backup method and renders nothing
  // until the action is complete and the page is redirected.
  //
  // Using this route causes some missing-state errors to sometimes
  // appear in the console log. This is a result of multiple re-renders
  // happening as a result of state being wiped out while also
  // simultaneously trying to be rendered.
  // @ts-ignore @TODO Epic WT-21600
  dispatch(accountActions.logout(withError)).then(() => navigate('/login'));

  return null;
};

export { Logout };
